import { render, staticRenderFns } from "./PedidoConteudo.vue?vue&type=template&id=10602a2a&scoped=true"
import script from "./PedidoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoConteudo.vue?vue&type=style&index=0&id=10602a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10602a2a",
  null
  
)

export default component.exports